module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0 3rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "value": _vm.formData.saiqu.name,
      "title": "赛区"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.danwei,
      "title": "单位"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.mingcheng,
      "title": "队伍名称"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.subject_name,
      "title": "项目"
    }
  }), _vm._v(" "), (!_vm.canSubmit) ? _c('van-cell', {
    attrs: {
      "title": "视频"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.canSubmit && _vm.formData.video.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    ref: "vu",
    attrs: {
      "minSize": 0,
      "fileList": _vm.formData.video,
      "limit": 1,
      "fileName": _vm.formData.baoming.mingcheng + '-' + _vm.formData.subject_name,
      "name": 'video'
    },
    on: {
      "videoListChange": _vm.videoListChange,
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }), _vm._v(" "), _c('van-radio-group', {
    on: {
      "change": _vm.checkedChange
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [(_vm.canSubmit) ? _c('van-cell', {
    attrs: {
      "title": "视频1"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_vm._v("\n        点击选择视频1\n      "), _c('van-radio', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "name": "1",
            "checked-color": "#ffb01b"
          },
          on: {
            "click": function($event) {
              _vm.checked = '1'
            }
          }
        })]
      },
      proxy: true
    }], null, false, 3517202005)
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video.length == 0 && _vm.isAndroid) ? _c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.beforeUpload($event)
      }
    }
  }, [_c('div', {
    staticClass: "uploader-wrap"
  }, [_c('div', {
    staticClass: "uploader-content"
  }, [_c('van-icon', {
    attrs: {
      "name": "video",
      "size": "24",
      "color": "#dcdee0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-text",
    staticStyle: {
      "color": "#969799",
      "font-size": "12px"
    }
  }, [_vm._v("\n              拍摄视频1\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), ((_vm.canSubmit && _vm.formData.video.length > 0) || (_vm.canSubmit && _vm.formData.video.length == 0 && !_vm.isAndroid)) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    ref: "vu",
    attrs: {
      "minSize": 0,
      "fileList": _vm.formData.video1,
      "limit": 1,
      "fileName": _vm.formData.baoming.mingcheng + '-' + _vm.formData.subject_name,
      "name": 'video'
    },
    on: {
      "videoListChange": _vm.videoListChange,
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }), _vm._v(" "), (_vm.canSubmit && _vm.formData.video1.length > 0) ? _c('van-cell', {
    attrs: {
      "title": "视频2"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_vm._v("\n        点击选择视频2\n      "), _c('van-radio', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "name": "2",
            "checked-color": "#ffb01b"
          },
          on: {
            "click": function($event) {
              _vm.checked = '2'
            }
          }
        })]
      },
      proxy: true
    }], null, false, 3166421974)
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video.length == 0 && _vm.isAndroid && _vm.formData.video1.length > 0) ? _c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.beforeUpload($event)
      }
    }
  }, [_c('div', {
    staticClass: "uploader-wrap"
  }, [_c('div', {
    staticClass: "uploader-content"
  }, [_c('van-icon', {
    attrs: {
      "name": "video",
      "size": "24",
      "color": "#dcdee0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-text",
    staticStyle: {
      "color": "#969799",
      "font-size": "12px"
    }
  }, [_vm._v("\n              拍摄视频2\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), ((_vm.canSubmit && _vm.formData.video.length > 0) || (_vm.canSubmit && _vm.formData.video.length == 0 && !_vm.isAndroid && _vm.formData.video1.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    ref: "vu",
    attrs: {
      "minSize": 0,
      "fileList": _vm.formData.video2,
      "limit": 1,
      "fileName": _vm.formData.baoming.mingcheng + '-' + _vm.formData.subject_name,
      "name": 'video'
    },
    on: {
      "videoListChange": _vm.videoListChange,
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video2.length > 0) ? _c('van-cell', {
    attrs: {
      "title": "视频3"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_vm._v("\n        点击选择视频3\n      "), _c('van-radio', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "name": "3",
            "checked-color": "#ffb01b"
          },
          on: {
            "click": function($event) {
              _vm.checked = '3'
            }
          }
        })]
      },
      proxy: true
    }], null, false, 2814717783)
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit && _vm.formData.video.length == 0 && _vm.isAndroid && _vm.formData.video2.length > 0) ? _c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.beforeUpload($event)
      }
    }
  }, [_c('div', {
    staticClass: "uploader-wrap"
  }, [_c('div', {
    staticClass: "uploader-content"
  }, [_c('van-icon', {
    attrs: {
      "name": "video",
      "size": "24",
      "color": "#dcdee0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-text",
    staticStyle: {
      "color": "#969799",
      "font-size": "12px"
    }
  }, [_vm._v("\n              拍摄视频3\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), ((_vm.canSubmit && _vm.formData.video.length > 0) || (_vm.canSubmit && _vm.formData.video.length == 0 && !_vm.isAndroid && _vm.formData.video2.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    ref: "vu",
    attrs: {
      "minSize": 0,
      "fileList": _vm.formData.video3,
      "limit": 1,
      "fileName": _vm.formData.baoming.mingcheng + '-' + _vm.formData.subject_name,
      "name": 'video'
    },
    on: {
      "videoListChange": _vm.videoListChange,
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 15px",
      "background": "#fffbe8",
      "color": "#ed6a0c"
    },
    on: {
      "click": _vm.onDownload
    }
  }, [_vm._v("如果视频无法上传，请点击这里下载最新版")])], 1), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c47012","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormUploadVideoLive.vue
// module id = 2484
// module chunks = 0